import 'slick-carousel';
export function conceptFunc() {
    var $slider, $sliderMin, nowNum, onNum;
    $slider = $('#jsCon ul');
    $sliderMin = $('#jsConM ul');
    $slider.slick({
        autoplay: true,
        autoplaySpeed: 8000,
        default: 1,
        swipe: true,
        dots: false,
        pauseOnHover: false,
        infinite: true,
    }).on('afterChange', function (event, slick, currentSlide, nextSlide) {
        nowNum = $slider.slick('slickCurrentSlide')
        $sliderMin.find('li').removeClass('active').eq(nowNum).addClass('active');
    });

    $('#jsConM ul li').on('click', function () {
        onNum = $(this).data('number');
        $('#jsConM ul').find('li').removeClass('active');
        $(this).addClass('active');
        $slider.slick('slickGoTo', onNum);
    });
}


//////////////////
// WEBPACK FOOTER
// ./src/js/pages/_concept.js
// module id = 15
// module chunks = 0